import React from 'react';
import { twMerge } from 'utilities/src/twMerge';

import { IMessageErrorProps } from './_props';

import IconComponent from '../../../../Icon';

import useInputMessageErrorTheme from './themes';

/**
 * MessageError Component
 */

function MessageError({
  message,
  icon = undefined,
  state,
  theme,
  className,
  errorSpace = false,
}: IMessageErrorProps) {
  const {
    messageErrorWrapperThemeClasses,
    messageErrorTextThemeClasses,
    messageErrorTextColorThemeClasses,
    messageErrorIconColorThemeClasses,
  } = useInputMessageErrorTheme({ inputTheme: theme });

  const returnValue = errorSpace ? <div className="h-[1.125rem]" /> : null;

  if (state !== 'Error' || !message) return returnValue;

  return (
    <div className={messageErrorWrapperThemeClasses}>
      <IconComponent
        Icon={icon}
        size="IconS"
        options={{
          className: twMerge(messageErrorIconColorThemeClasses, className),
        }}
      />

      <span className={twMerge(messageErrorTextThemeClasses, messageErrorTextColorThemeClasses, className)}>
        {message}
      </span>
    </div>
  );
}

export default MessageError;
